import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Use relative URL when running in browser so requests are same-origin.
// This avoids CORS issues caused by the K8s ingress overriding CORS headers
// with wildcard ACAO + credentials (which browsers reject).
const isBrowser = typeof window !== "undefined";
export const API_BASE = isBrowser ? "/api" : `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // Bilingual error shape { en, hi }
  if (detail && typeof detail === "object" && (detail.en || detail.hi)) {
    if (detail.en && detail.hi) return `${detail.en}\n${detail.hi}`;
    return detail.en || detail.hi;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
